import { Box, Button, Typography } from '@mui/material';

import type { ReportType } from '../../types/documentTypes.generated';
import { listaDeDocumentos } from './marcacaoDeDocumentos';

interface SugestaoDeDocumentosProps {
  /** O que acontece se nada for marcado (D7). */
  texto: string;
  /** A marcação da maioria dos riscos do alcance; ausente, não há botão. */
  sugestao?: readonly ReportType[];
  aoMarcar: (tipos: ReportType[]) => void;
  disabled?: boolean;
}

/**
 * Documentos não vêm pré-marcados (#606, D7): a tela explica o que acontece sem marcação e,
 * quando o alcance tem uma maioria, oferece marcá-la num clique.
 */
export function SugestaoDeDocumentos({ texto, sugestao, aoMarcar, disabled = false }: SugestaoDeDocumentosProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Marque os documentos em que o risco deve aparecer. {texto}
      </Typography>
      {sugestao && sugestao.length > 0 && (
        <Button
          type="button"
          size="small"
          variant="outlined"
          sx={{ mt: 1 }}
          disabled={disabled}
          onClick={() => aoMarcar([...sugestao])}
        >
          Marcar como a maioria ({listaDeDocumentos(sugestao)})
        </Button>
      )}
    </Box>
  );
}

interface ResumoDoEfeitoProps {
  titulo: 'Ao salvar' | 'Ao aplicar';
  linhas: string[];
}

/** O quadro que diz o efeito antes de gravar (#606, §4.3 e §4.4). */
export function ResumoDoEfeito({ titulo, linhas }: ResumoDoEfeitoProps) {
  if (linhas.length === 0) return null;
  const idDoTitulo = `resumo-${titulo === 'Ao salvar' ? 'salvar' : 'aplicar'}`;
  return (
    <Box
      component="section"
      aria-labelledby={idDoTitulo}
      sx={{ mt: 2, p: 2, borderRadius: 1, bgcolor: 'action.hover' }}
    >
      <Typography id={idDoTitulo} variant="subtitle2" sx={{ mb: 0.5 }}>
        {titulo}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {linhas.map((linha) => (
          <Typography component="li" variant="body2" key={linha}>
            {linha}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
